import React from "react";
import { useAccess } from "@/lib/access";
import AccessRestricted from "@/pages/AccessRestricted";

/**
 * Gate route children behind area access.
 * Usage:  <AreaGuard area="sales"><Layout /></AreaGuard>
 */
export default function AreaGuard({ area, children }) {
  const { loading, areas, error } = useAccess();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500 text-sm">
        Verifying access…
      </div>
    );
  }
  if (error || !areas.includes(area)) {
    return <AccessRestricted reason={error} area={area} />;
  }
  return children;
}
